import axios from 'axios'


const baseUrl = `${process.env.VUE_APP_PROTOCOL}://${window.location.hostname}/authentication/api/v1`;

const authLanguageClient = axios.create({
    baseURL: baseUrl
})

export default authLanguageClient